import React from "react";
import styles from "./box.module.scss";
// import medicalradiolgraphy2 from "../../../assets/row-medical-radiolgraphy2.png";
// import family from '../../../assets/family.JPG'
// import blog from '../../../assets/blog-events.jpg'
// import ABOUT_MILL from '../../../assets/ABOUT_MILL.jpg'
import ABOUT_MILL from '../../../assets/new-banners/square_banner.png'
// import rowmedical from "../../../assets/row-medical-computed-radiography.png";
// import analog_horizon from "../../../assets/row-medical-analog-horizon.jpg";
// import medicalsoftware from "../../../assets/row-medical-software.png";
// import medicalprinting from "../../../assets/row-medical-printing.png";
// import medicaldental from "../../../assets/row-medical-dental.png";
import { Link } from "react-router-dom";
// import trust_MILLENSYS from '../../../assets/checkmark.png'
// import { GoDotFill } from "react-icons/go";
import { AiFillSafetyCertificate } from "react-icons/ai";

const Box = () => {
  return (
    <section className={styles.box_container}>
      <div className={styles.___container}>
        {/* Box 1  */}
        {/* <div className={styles.__box}>
          <div className={styles.__box_main}>
            <div className={styles.__box_leftside}>
              <div className={styles.__box_image}>
                <img src={family} alt='MILLENSYS family' />
              </div>
            </div>
            <div className={styles.__box_rightside}>
              <Link to='/about' className={styles._headding}>
              Who we are ?
              </Link>
              <strong className={styles.__strong}>
              MILLENSYS is leader in healthcare software and IT solutions
              </strong>
              <p className={styles.__content}>
              providing innovative solutions to healthcare service providers to run their daily business in a quick, 
              safe, efficient way and be able to achieve operational excellence, satisfy their patients and stakeholders,
              leverage their provided quality of service and increase their profits.
              </p>
              <p className={styles.__content}>
              MILLENSYS software solutions to the healthcare ecosystem help as many as hospitals, medical centers and polyclinics, 
              diagnostic centers, radiology scan centers, laboratories, health insurance organizations, billing and claim management firms,
              telehealth - teleradiology and telemedicine companies manage their business more professionally.
              </p>
            </div>
          </div>
        </div> */}

        {/* Box 2  */}
        <div className={styles.__box}>
          <div className={styles.__box_main}>
            <div className={styles.__box_rightside}>
              <Link to='/about' className={styles._headding}>
              {/* <img src={trust_MILLENSYS} alt="trust_MILLENSYS" className={styles.iconImg}/> */}
              <AiFillSafetyCertificate className={styles.iconImg} />
              Why Choose Us?
              </Link>
              <strong className={styles.__strong}>
              MILLENSYS is dedicated to revolutionizing healthcare delivery through innovative solutions.
              Our advanced telemedicine and teleradiology platforms, coupled with AI-driven insights, 
                enable remote diagnosis and treatment, 
              </strong>
              <p className={styles.__content}>
    
                saving healthcare providers valuable time while maximizing patient care.
                By harnessing the power of cloud technology and adhering to industry standards like IHE/HL7, 
                we ensure seamless integration and secure data management.
                Our commitment to exceptional customer service complements our technological prowess, 
                providing timely support and optimizing your return on investment. 
                Partner with MILLENSYS to elevate patient care, enhance efficiency, and drive business growth.
              </p>
              {/* <p className={styles.__content}>
              IHE / HL7 software engine for integration ,
              CRM software for customer relation management , complete financial management ERP for managing billing, claims, accounting,
              inventory and human resources plus business intelligence tools and mobile applications for patient engagement.
              </p> */}
              <button className={styles["product___btn"]}>
                <Link to={'/about'}>Learn More About Us</Link>
              </button>
            </div>
            <div className={styles.__box_leftside}>
              <div className={styles.__box_image}>
                <img src={ABOUT_MILL} alt='MILLENSYS-blog-events' loading="lazy"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Box;
